<template>
  <div>
    <div class="content ">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <!-- <span class="masge">当前共有{{ total }}个模块</span> -->
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" type="danger" :disabled="multiple" v-preventReClick @click="handleDelete">
            删除
          </el-button>
        </div>
        <div class="right">
          <!-- <div class="search">
          <select v-model="query.appId" placeholder="请选择所属应用" @change="appIdChange" width="180px">
            <option v-for="item in AppCategory" :key="item.id" :label="item.name" :value="item.id">{{item.name}}</option>
          </select>
        </div> -->
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <!-- <el-tabs v-model="query.appId" @tab-click="tabClick">
        <el-tab-pane v-for="item in AppCategory" :key="item.id" :label="item.name" :name="item.id"></el-tab-pane>
      </el-tabs>  -->
      <el-tabs v-model="query.appId" @tab-click="tabClick" stretch>
        <el-tab-pane v-for="item in apps" :key="item.id" :name="item.id + ''">
          <template slot="label">
            <span style="margin: 0 10px"> {{ item.name }} </span>
          </template>
        </el-tab-pane>
      </el-tabs>

      <el-table v-loading="loading" border row-key="id" ref="multipleTable" :data="tableData" :max-height="tableHeight" :tree-props="{ children: 'children' }" style="width: 100%;margin-top:10px" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="name" label="名称" width="180">
        </el-table-column>
        <el-table-column prop="parentName" label="父模块">
          <template slot-scope="scope">
            {{ scope.row.parentName??'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="code" label="编码"></el-table-column>
        <el-table-column prop="sort" label="排序" width="55"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" width="170" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="stateName" label="是否展示" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="operation" fixed="right" label="操作" width="180px">
          <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" class="margin-left20 color-blue" v-preventReClick @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="title + '模块'" :visible.sync="open" :center="true" width="1100px" :before-close="cancel" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
          <el-row>
            <el-col :span="12">
              <el-form-item label="名称" prop="name">
                <el-input v-model="form.name" :disabled="!editMode" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="父模块" prop="parentId">
                <el-select v-model="form.parentId" :disabled="!editMode" placeholder="请选择父模块" filterable :filter-method="getParentId" style="width: 100%;" @change="parentModeuleChange">
                  <el-option v-for="item in parentList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="菜单类型" prop="type">
                <el-radio-group :disabled="!editMode" v-model="form.type">
                  <el-radio :label="0">分组</el-radio>
                  <el-radio :label="1">普通表单</el-radio>
                  <el-radio :label="2">报表</el-radio>
                  <el-radio :label="3">流程表单</el-radio>
                  <el-radio :label="4">积木报表</el-radio>
                  <el-radio :label="5">润乾报表</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="菜单图标">
                <!-- <el-popover placement="bottom-start" width="460" trigger="click" @show="$refs['iconSelect'].reset()">
                <IconSelect ref="iconSelect" @selected="selected" />
                <el-input slot="reference" v-model="form.icon" placeholder="点击选择图标" readonly>
                  <svg-icon v-if="form.icon" slot="prefix" :icon-class="form.icon" class="el-input__icon" style="height: 32px;width: 16px;" />
                  <i v-else slot="prefix" class="el-icon-search el-input__icon" />
                </el-input>
              </el-popover> -->
                <el-popover placement="bottom-start" :disabled="!editMode" width="460" trigger="click" @show="iconShow" @hide="iconHide">
                  <div class="icon-select-input" :class="isIconShow ? 'on' : ''" slot="reference">
                    <span class="icon-select-placeholder" v-show="form.icon == '' || form.icon == null">点击选择图标</span>
                    <span v-show="form.icon != ''" class="iconfont" :class="'icon-' + form.icon"></span>
                  </div>
                  <div class="icon-select-div">
                    <div class="icon-card" :span="3" v-for="(item, index) in iconList" :key="index" v-preventReClick @click="iconChange(item)">
                      <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                        <span class="iconfont icon-select" :class="'icon-' + item.font_class"></span>
                      </el-tooltip>
                    </div>
                  </div>
                </el-popover>
                <!-- <el-input v-model="form.icon" placeholder="" /> -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="模块编码" prop="code">
                <el-input v-model="form.code" :disabled="!editMode" placeholder="请输入模块编码" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="流水号前缀" prop="noPrefix">
                <el-input v-model="form.noPrefix" :disabled="!editMode" placeholder="请输入流水号前缀" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="流水号日期类型" prop="noCategory">
                <el-radio-group :disabled="!editMode" v-model="form.noCategory">
                  <el-radio :label="0">天</el-radio>
                  <el-radio :label="1">月</el-radio>
                  <el-radio :label="2">年</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="路由地址" prop="path">
                <el-input v-model="form.path" :disabled="!editMode" placeholder="请输入路由地址" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="组件路径" prop="component">
                <el-input v-model="form.component" :disabled="!editMode" placeholder="请输入组件路径,报表请填写：components/report/index.vue" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="显示排序" prop="sort">
                <el-input-number style="width: 100%" :disabled="!editMode" v-model="form.sort" controls-position="right" :min="0" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否展示" prop="state">
                <el-radio-group :disabled="!editMode" v-model="form.state">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="描述">
                <el-input :disabled="!editMode" v-model="form.desc"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
          <my-button class="btn primary" type="primary" v-if="editMode" size="small" v-preventReClick @click="submit">确 定</my-button>
        </div>
      </el-dialog>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  GetModules,
  RemoveModules,
  SaveModule,
  GetParentId,
  GetModuleTreeList,
} from "@/api";
// import { AppCategory } from "@/enum";
// import IconSelect from '@/components/iconSelect.vue'
import GetDataMixin from "@/mixin/getData-mixin.js";
import iconfontList from "@/assets/ali-icon/iconfont.json";

export default {
  components: {
    // IconSelect
  },
  mixins: [GetDataMixin],
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        appId: "1",
      },
      // 遮罩层
      loading: true,
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      // 弹出编辑框
      open: false,
      editMode: false,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      // 列表多选
      multiple: true,
      // app 列表
      // AppCategory: AppCategory,
      rules: {
        path: [{ required: true, message: "请输入路由", trigger: "blur" }],
        name: [{ required: true, message: "请选择名称", trigger: "blur" }],
      },
      moduleList: [],
      // 父模块
      parentList: [],
      iconList: [],
      isIconShow: false,
    };
  },
  computed: {
    apps () {
      return this.$store.state.user.apps;
    },
  },
  methods: {
    handleSelectionChange (selection) {
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData () {
      this.loading = true;
      GetModuleTreeList(this.query).then((res) => {
        this.tableData = res.returnData;
        // this.total = res.returnData.totalCount;
        this.loading = false;
      });
    },
    // 新建
    handleAdd () {
      this.open = true;
      this.resetForm();
      this.editMode = true;
      this.title = "新建";
    },
    handleInfo (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.$set(this.form,'noPrefix',row.noPrefix)
      this.open = true;
      this.editMode = false;
    },
    // 编辑
    handleUpdate (row) {
      this.resetForm();
      
      this.form = JSON.parse(JSON.stringify(row));
      if (this.form.parentId == 0) {
        this.form.parentId = null;
      }
      // this.$set(this.form,'noPrefix',row.noPrefix)
      this.open = true;
      this.editMode = true;
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveModule(this.form).then((res) => {
          // if (res.successful == false) {
          //   this.$my_message(res.errorMessage,"error")
          //   return;
          // }
          this.open = false;
          this.$my_message(`执行成功`, "success");
          this.getData();
          this.getParentId();
        });
      });
    },
    resetForm () {
      this.form = {
        appId: this.query.appId,
        name: "",
        type: 0,
        state: 1,
        noCategory: 0,
        noPrefix:'',
        orgCode :sessionStorage.getItem('orgId'),

      };
    },
    // 取消编辑部门
    cancel () {
      if (this.editMode) {
        this.$my_confirm("确认要中断当前操作吗？", "提示", {
          type: "warning",
        })
          .then(() => {
            this.open = false;
          })
          .catch(() => { });
      } else {
        this.open = false;
      }
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },
    tabClick () {
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      // this.$set(this.query, 'appId', id);
      this.getData();
      this.getParentId();
    },
    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("确认要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemoveModules({ ids });
        })
        .then(() => {
          this.$my_message(`删除成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        appId: "1",
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    appIdChange (val) {
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
      this.getModules("");
    },
    parentModeuleChange (val) {
      this.form.parentId = val;
    },
    getModules (keyWord) {
      GetModules({
        keyWord: keyWord,
        pageSize: 100,
        pageIndex: 1,
        appId: this.query.appId,
      }).then((res) => {
        this.moduleList = res.returnData.data;
      });
    },
    getParentId (keyWord) {
      GetParentId({
        keyWord: keyWord,
        pageSize: 100,
        pageIndex: 1,
        appId: this.query.appId,
      }).then((res) => {
        this.parentList = res.returnData.data;
      });
    },
    iconChange (item) {
      this.$set(this.form, "icon", item.font_class);
    },
    iconShow () {
      this.isIconShow = true;
    },
    iconHide () {
      this.isIconShow = false;
    },
  },
  mounted () {
    this.getData();
    this.getModules("");
    this.getParentId();
    this.iconList = iconfontList.glyphs;
  },
};
</script>

<style lang="scss" scoped>
.el-tabs {
  width: 360px;
  margin-bottom: 10px;
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 26px;
}
.icon-select-input {
  height: 36px;
  line-height: 36px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
  padding: 0 15px;
  color: #c0c4cc;
  transition: 0.2s;
  .iconfont {
    color: #286ab4;
    margin-top: 6px;
  }
  .icon-select-placeholder {
    display: block;
    font-size: 14px;
  }
}
.icon-select-input.on {
  border: 1px solid #286ab4;
  transition: 0.2s;
}
.icon-select-div {
  padding: 6px 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .icon-card {
    border: 1px solid #bbbbbb;
    color: #abafbf;
    border-radius: 5px;
    padding: 3px;
    margin: 5px;
    text-align: center;
    cursor: pointer;
  }
  .icon-card:hover {
    border: 1px solid #bfd2e9;
    color: #286ab4;
    background-color: #eaf0f8;
  }
}
.icon-select {
  width: 20px;
  height: 20px;
}
</style>
